import { createAction, props } from '@ngrx/store';
import type { CommentUser } from '@candyland/generic/tt-com-comments/models';

export const setCommentUserDetails = createAction('[Comment User] Set Comment User Details', props<CommentUser>());
